import type { ImageValue } from "../media-shared";

export const imagePositions = ["left top", "center top", "right top", "left center", "center center", "right center", "left bottom", "center bottom", "right bottom"] as const;

export function imagePresentation(value: ImageValue | null | undefined, options: {
  fit?: "cover" | "contain"; position?: string;
  defaultFit?: "cover" | "contain"; defaultPosition?: string;
} = {}) {
  const fit = options.fit || value?.fit || options.defaultFit;
  const position = options.position || value?.position || options.defaultPosition;
  return {
    fit: fit === "contain" ? "contain" as const : "cover" as const,
    position: imagePositions.includes(position as typeof imagePositions[number]) ? position! : "center center",
  };
}
